<template>
  <MainLayout v-if="currentPage === 'dashboard'" :title="$t('pages.dashboard')">
    <template slot="leftElements">
      <ChartFilters page="dashboard" />
    </template>
    <template slot="rightElements">
      <VsMonthPicker :selectedGlobalDate="selectedDate" @new-month-date="setNewDate" />
    </template>
    <div slot="content">
      <DashboardChartAndRanking />
    </div>
  </MainLayout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { subMonths } from "date-fns";
import MainLayout from "@/layouts/Main";
import DashboardChartAndRanking from "@/components/dashboard/Index";
import ChartFilters from "@/components/shared/ChartFilters/Index";

export default {
  components: {
    MainLayout,
    DashboardChartAndRanking,
    ChartFilters,
  },
  computed: {
    ...mapGetters({
      selectedDate: "dashboard/dashBoardSelectedDate",
      currentPage: "dashboard/currentPage",
    }),
  },
  created() {
    if (!this.selectedDate) {
      const date = subMonths(new Date(), 1);
      this.setDashboardDate(date);
    }
  },
  methods: {
    ...mapActions("dashboard", ["setDashboardDate"]),
    setNewDate(date) {
      this.setDashboardDate(date);
    },
  },
};
</script>
